import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CustomFormsHelpersSearchFiltersStatusMainComponent } from './main/main.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        CustomFormsHelpersSearchFiltersStatusMainComponent
    ],
    exports: [
        CustomFormsHelpersSearchFiltersStatusMainComponent
    ],

})
export class CoreCustomFormsHelpersSearchFiltersStatusModule { }